import { defineMessages } from 'react-intl'


export default defineMessages({
  none: {
    defaultMessage: 'None',
    id: 'tcf-details.none',
  },
})
